import { Component } from '@angular/core';
import { NativeAppService } from '../../common/native-app-service/native-app.service';
import { ActivatedRoute } from '@angular/router';
import { RequestAccessConfig } from './request-access.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'request-access',
  templateUrl: './request-access.component.html',
  styleUrls: ['./request-access.component.scss']
})
export class RequestAccessComponent {
  constructor(
    private readonly nativeAppService: NativeAppService,
    private readonly route: ActivatedRoute
  ) {}
  pageName: string | null = null;
  pageConfig: RequestAccessConfig = {
    label: 'Default',
    icon: 'request_access',
    header: 'OH_NO.TITLE',
    body: 'OH_NO.SUBSCRIPTION_ERROR',
    footer: 'OH_NO.SUGGESTION'
  };
  queryParamsSubscription: Subscription = new Subscription();

  private readonly requesAccessPageConfigs: {
    [key: string]: RequestAccessConfig;
  } = {
    'patient-chat': {
      label: 'Patient Chat',
      icon: 'patient_chat',
      header: 'OH_NO.PATIENT_CHAT.HEADER',
      body: 'OH_NO.PATIENT_CHAT.BODY',
      footer: 'OH_NO.PATIENT_CHAT.FOOTER',
      url: 'https://info.dentalintel.com/cbj'
    },
    'team-chat': {
      label: 'Team Chat',
      icon: 'team_chat',
      header: 'OH_NO.TEAM_CHAT.HEADER',
      body: 'OH_NO.TEAM_CHAT.BODY',
      footer: 'OH_NO.TEAM_CHAT.FOOTER',
      url: 'https://info.dentalintel.com/rh0'
    },
    stats: {
      label: 'Analytics',
      icon: 'analytics',
      header: 'OH_NO.ANALYTICS.HEADER',
      body: 'OH_NO.ANALYTICS.BODY',
      footer: 'OH_NO.ANALYTICS.FOOTER',
      url: 'https://info.dentalintel.com/fp3'
    },
    default: {
      label: 'default',
      icon: 'request_access',
      header: 'OH_NO.DEFAULT.HEADER',
      body: 'OH_NO.DEFAULT.BODY',
      footer: 'OH_NO.DEFAULT.FOOTER'
    }
  };

  ngOnInit(): void {
    this.queryParamsSubscription = this.route.queryParams.subscribe(
      (params) => {
        this.pageName = params['pageName'];
        this.setPageConfiguration();
      }
    );
  }

  ngOnDestroy(): void {
    this.queryParamsSubscription.unsubscribe();
  }

  private setPageConfiguration(): void {
    if (this.pageName && this.requesAccessPageConfigs[this.pageName]) {
      this.pageConfig = this.requesAccessPageConfigs[this.pageName];
    } else {
      this.pageConfig = this.requesAccessPageConfigs['default'];
    }
  }

  navigateTo(url: string) {
    this.nativeAppService.openExternalUrlOnNewTab(url);
  }
}
